import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  getProducts(storeId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/categories/products?storeId=${storeId}&allStatus=true`, httpOptions);
  }

  updateProduct(id, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/products/${id}/status`, status, httpOptions);
  }

  constructor(private http: HttpClient) { }
}

